<template>
  <div>
    <div class="anamnese-title">
      <span>4/5</span>
      <h4>{{ answers.four.name }}</h4>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A. {{ answers.four.a.question }}</h4>
            <div
              v-if="answers.four.a.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.four.a.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.four.a.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('four', 'a', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.four.a.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('four', 'a', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.four.a.explanation"
      ></textarea>
    </div>
  </div>
</template>

<script>
import useAnswers from "../../composables/useAnswers.js";

export default {
  components: {},
  setup() {
    const { answers } = useAnswers();

    const onClickBoolean = (question, letter, answer) => {
      if (answers.value[question][letter].answer == answer) {
        answers.value[question][letter].answer = "";
      } else {
        answers.value[question][letter].answer = answer;
      }
    };

    return { answers, onClickBoolean };
  },
};
</script>

<style scoped>
@media (min-width: 991px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 225px;
  }
}
@media (min-width: 1442px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 300px;
  }
}
</style>
